import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConnectionService } from '../../services/connection.service';
import { LoaderService } from '../../services/loader.service';
import { StorageService } from '../../services/storage.service';
import { ToastService } from '../../services/toast.service';


@Component({
  selector: 'app-vehicle-quote-form',
  templateUrl: './vehicle-quote-form.page.html',
  styleUrls: ['./vehicle-quote-form.page.scss'],
})
export class VehicleQuoteFormPage implements OnInit {
  vehicleQuoteForm: FormGroup;
  vehicleType = {
    "isBike": false,
    "isCar": false,
    "pageId": 0
  }
  routeOne: any;

  carModelFilters = {
    "brand": '',
    "fuelType": '',
    "model": '',
    "variant": '',
  }
  minDate: any;
  maxDate: any;
  formReq: boolean = false
  curYear: number;
  withReg: boolean;
  data: any;
  rollOver: boolean;
  policyDontKnow: boolean;
  showRegYear: boolean;
  showNcb: boolean;
  ncbDetail: boolean;
  noOfClaim: any;
  businessType: any;
  findYear: number;
  findDay: number;
  claimCount: any;
  bothFiled: boolean;
  regYear: Date;
  month: number;
  day: number;
  maxiDate: any;
  maxYear: number;
  endOfDate: any;
  miniDate: any;
  mday: any;
  vehicleQuoteList: any = [];
  constructor(
    private fb: FormBuilder,
    private toast: ToastService,
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ConnectionService,
    private datePipe: DatePipe,
    private strg: StorageService,
    private loader: LoaderService
  ) { }
  validatorErrorMsg = {
    'qtFullName': {
      'required': 'Name is required'
    },
    'qtMobile': {
      'required': 'Mobile is required',
      'pattern': 'Please enter valid Mobile Number'
    },
    "qtEmail": {
      'required': 'Email is required',
      'pattern': 'Please enter valid email'
    },
    "qtRegNumber": {
      'required': 'Registration number is required'
    },
    "qtBrand": {
      'required': 'Brand is required'
    },
    "qtModel": {
      'required': 'Model is required'
    },
    "qtFuel": {
      'required': 'Fuel is required'
    },
    "qtRto": {
      "required": 'RTO is required'
    },
    "qtVariant": {
      "required": 'Variant field is required'
    },
    "qtRegYear": {
      "required": 'Registration year field is required',
      "regError": 'Invalid date'
    },
    "nw_qtRegYear": {
      "required": 'Registration year field is required',
    },
    "owenerTransfer": {
      "required": 'Owner Transfer field is required'
    },
    "qtExpireStart": {
      "regInvalid": 'invalid date compared to registration date'
    }

  }
  formValidatorErr = {
    'qtFullName': '',
    'qtMobile': '',
    'qtEmail': '',
    'qtRegNumber': '',
    'qtBrand': '',
    'qtModel': '',
    'qtFuel': '',
    'qtExpireStart': '',
    'qtExpireEnd': '',
    'qtRto': '',
    'qtVariant': '',
    'qtRegYear': '',
    'nw_qtRegYear': '',
    'qtExistClaim': '',
    'owenerTransfer': '',
  }
  getFormControl(ControlName) {
    return this.vehicleQuoteForm.get(ControlName);
  }

  ionViewDidEnter() {
    this.noOfClaim = ''
    this.rollOver = false;
    this.policyDontKnow = false;
    this.curYear = new Date().getFullYear()
    this.maxYear = new Date().getFullYear() - 1
    let a = new Date()
    let date = new Date(this.maxYear + "-" + (a.getMonth() + 1) + "-" + a.getDate())
    this.maxiDate = this.datePipe.transform(date, 'yyyy-MM-dd')
    this.route.params.subscribe(params => {
      let routeOne = params['vehicleType'];
      this.vehicleType.pageId = 1
      if (routeOne == "bike") {
        this.vehicleType.isBike = true;
        this.vehicleType.isCar = false;
      }
      else if (routeOne == "car") {
        this.vehicleType.isCar = true
        this.vehicleType.isBike = false;
      }
      if (this.vehicleType.pageId == 1) {
        this.vehicleQuoteForm.get('qtFullName').setValidators(Validators.required)
        this.vehicleQuoteForm.get('qtMobile').setValidators([Validators.required, Validators.pattern('[6-9]\\d{9}')])
        this.vehicleQuoteForm.get('qtEmail').setValidators([Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')])
        this.vehicleQuoteForm.get('qtRegNumber').setValidators([Validators.required])
      }
      else {
        this.vehicleQuoteForm.get('qtFullName').updateValueAndValidity()
        this.vehicleQuoteForm.get('qtFullName').clearValidators()
        this.vehicleQuoteForm.get('qtMobile').updateValueAndValidity()
        this.vehicleQuoteForm.get('qtMobile').clearValidators()
        this.vehicleQuoteForm.get('qtEmail').updateValueAndValidity()
        this.vehicleQuoteForm.get('qtEmail').clearValidators()
        this.vehicleQuoteForm.get('qtRegNumber').updateValueAndValidity()
        this.vehicleQuoteForm.get('qtRegNumber').clearValidators()
      }

    })
    this.getCarModelList();
    var d = new Date();
    d.setDate(d.getDate() - 15);
    d.toLocaleString()
    this.minDate = this.datePipe.transform(d, 'yyyy-MM-dd')
    this.maxDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd')
  }

  ngOnInit() {
    this.vehicleQuoteForm = this.fb.group({
      qtFullName: [''],
      qtMobile: [''],
      qtEmail: ['',Validators.pattern('^[a-zA-Z0-9_+&*-]+(?:\\.+[a-zA-Z0-9_+&*-]+)*@+(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,4}$')],
      qtRegNumber: [''],
      qtBrand: ['',],
      qtModel: ['',],
      qtFuel: ['',],
      qtExpireStart: [''],
      qtExpireEnd: [''],
      qtRto: ['',],
      qtVariant: [''],
      qtRegYear: [''],
      nw_qtRegYear: [''],
      qtExistClaim: [''],
      owenerTransfer: ['']

    })
    this.vehicleQuoteForm.valueChanges.subscribe(res => this.logValidationErrorsOnChange());
  }
  logValidationErrorsOnChange(group: FormGroup = this.vehicleQuoteForm) {
    Object.keys(group.controls).forEach((key: string) => {
      const getFormControlKey = group.get(key);
      this.formValidatorErr[key] = '';
      if (getFormControlKey && !getFormControlKey.valid && (getFormControlKey.touched || getFormControlKey.dirty)) {
        const errorMsg = this.validatorErrorMsg[key];
        for (const errorKey in getFormControlKey.errors) {
          if (errorKey) {
            if (errorKey === 'required') {
              this.formValidatorErr[key] = errorMsg[errorKey]
              break;
            } else {
              this.formValidatorErr[key] += errorMsg[errorKey] + ' ';
            }
          }
        }
      }
    });
  }

  logValidationErrors1(group: FormGroup = this.vehicleQuoteForm) {
    Object.keys(group.controls).forEach((key: string) => {
      const getFormControlKey = group.get(key);
      this.formValidatorErr[key] = '';
      if (getFormControlKey && (!getFormControlKey.touched || !getFormControlKey.dirty)) {
        getFormControlKey.markAsTouched({ onlySelf: true });
        const errorMsg = this.validatorErrorMsg[key];
        for (const errorKey in getFormControlKey.errors) {
          if (errorKey) {
            if (errorKey === 'required') {
              this.formValidatorErr[key] = errorMsg[errorKey]
              break;
            } else {
              this.formValidatorErr[key] += errorMsg[errorKey] + ' ';
            }
          }
        }
      } else if (getFormControlKey && !getFormControlKey.valid && (getFormControlKey.touched || getFormControlKey.dirty)) {
        const errorMsg = this.validatorErrorMsg[key];
        for (const errorKey in getFormControlKey.errors) {
          if (errorKey) {
            if (errorKey === 'required') {
              this.formValidatorErr[key] = errorMsg[errorKey]
              break;
            } else {
              this.formValidatorErr[key] += errorMsg[errorKey] + ' ';
            }
          }
        }
      }
    });
  }
  proceedWithRoll() {
    this.showRegYear = true
    this.rollOver = true;
    if (this.vehicleQuoteForm.get('qtFullName').valid && this.vehicleQuoteForm.get('qtMobile').valid && this.vehicleQuoteForm.get('qtEmail').valid) {
      this.vehicleType.pageId = 2
      if (this.vehicleType.pageId == 2) {
        this.vehicleQuoteForm.get('qtBrand').setValidators(Validators.required)
        this.vehicleQuoteForm.get('qtModel').setValidators(Validators.required)
        this.vehicleQuoteForm.get('qtFuel').setValidators(Validators.required)
        this.vehicleQuoteForm.get('qtRto').setValidators(Validators.required)
        this.vehicleQuoteForm.get('qtRegYear').setValidators([Validators.required, regValidate])
        this.vehicleQuoteForm.get('qtExpireStart').setValidators(Validators.required)
        this.vehicleQuoteForm.get('qtExpireEnd').setValidators(Validators.required)
        this.vehicleQuoteForm.get('owenerTransfer').setValidators(Validators.required)
        this.vehicleQuoteForm.get('qtRegNumber').clearValidators()
        this.vehicleQuoteForm.get('qtRegNumber').updateValueAndValidity()
      }
      else {
        this.vehicleQuoteForm.get('qtBrand').clearValidators();
        this.vehicleQuoteForm.get('qtBrand').updateValueAndValidity();
        this.vehicleQuoteForm.get('qtModel').clearValidators();
        this.vehicleQuoteForm.get('qtModel').updateValueAndValidity();
        this.vehicleQuoteForm.get('qtFuel').clearValidators();
        this.vehicleQuoteForm.get('qtFuel').updateValueAndValidity();
        this.vehicleQuoteForm.get('qtRto').clearValidators();
        this.vehicleQuoteForm.get('qtRto').updateValueAndValidity();
        this.vehicleQuoteForm.get('qtRegYear').clearValidators();
        this.vehicleQuoteForm.get('qtRegYear').updateValueAndValidity();
        this.vehicleQuoteForm.get('qtExpireStart').clearValidators();
        this.vehicleQuoteForm.get('qtExpireStart').updateValueAndValidity();
        this.vehicleQuoteForm.get('qtExpireEnd').clearValidators()
        this.vehicleQuoteForm.get('qtExpireEnd').updateValueAndValidity()
        this.vehicleQuoteForm.get('owenerTransfer').clearValidators()
        this.vehicleQuoteForm.get('owenerTransfer').updateValueAndValidity()
      }
    }
    else {
      this.logValidationErrors1()
    }
  }
  proceedToInfo() {
    this.showRegYear = false;
    this.rollOver = false;
    if (this.vehicleQuoteForm.get('qtFullName').valid && this.vehicleQuoteForm.get('qtMobile').valid && this.vehicleQuoteForm.get('qtEmail').valid) {
      this.vehicleType.pageId = 2
      if (this.vehicleType.pageId == 2) {
        this.vehicleQuoteForm.get('qtRegYear').setValue('')
        this.vehicleQuoteForm.get('qtRegYear').clearValidators()
        this.vehicleQuoteForm.get('qtRegYear').updateValueAndValidity()
        this.vehicleQuoteForm.get('qtRegNumber').clearValidators()
        this.vehicleQuoteForm.get('qtRegNumber').updateValueAndValidity()
        this.vehicleQuoteForm.get('qtExpireStart').clearValidators()
        this.vehicleQuoteForm.get('qtExpireStart').updateValueAndValidity()
        this.vehicleQuoteForm.get('qtExpireEnd').clearValidators()
        this.vehicleQuoteForm.get('qtExpireEnd').updateValueAndValidity()
        this.vehicleQuoteForm.get('owenerTransfer').setValue('')
        this.vehicleQuoteForm.get('owenerTransfer').clearValidators()
        this.vehicleQuoteForm.get('owenerTransfer').updateValueAndValidity()
        this.vehicleQuoteForm.get('nw_qtRegYear').setValue(new Date().getFullYear())
        this.vehicleQuoteForm.get('qtBrand').setValidators(Validators.required)
        this.vehicleQuoteForm.get('qtModel').setValidators(Validators.required)
        this.vehicleQuoteForm.get('qtFuel').setValidators(Validators.required)
        this.vehicleQuoteForm.get('qtRto').setValidators(Validators.required)
      }
      else {
        this.vehicleQuoteForm.get('qtBrand').clearValidators();
        this.vehicleQuoteForm.get('qtBrand').updateValueAndValidity();
        this.vehicleQuoteForm.get('qtModel').clearValidators();
        this.vehicleQuoteForm.get('qtModel').updateValueAndValidity();
        this.vehicleQuoteForm.get('qtFuel').clearValidators();
        this.vehicleQuoteForm.get('qtFuel').updateValueAndValidity();
        this.vehicleQuoteForm.get('qtRto').clearValidators();
        this.vehicleQuoteForm.get('qtRto').updateValueAndValidity();
      }
    }
    else {
      this.logValidationErrors1()
    }
  }
  closeIt() {
    this.showNcb = false
  }
  goBackTo2() {
    this.vehicleType.pageId = 1
    this.vehicleQuoteForm.get('qtFullName').updateValueAndValidity()
    this.vehicleQuoteForm.get('qtFullName').clearValidators()
    this.vehicleQuoteForm.get('qtMobile').updateValueAndValidity()
    this.vehicleQuoteForm.get('qtMobile').clearValidators()
    this.vehicleQuoteForm.get('qtEmail').updateValueAndValidity()
    this.vehicleQuoteForm.get('qtEmail').clearValidators()
  }

  goBack() {
    this.vehicleType.pageId = 3
  }

  carBrandList: any;
  carFuelTypeList: any = [
    "Petrol",
    "Diesel",
    "Electric",
  ];
  carModelList: any;
  getCarModelList() {
    this.carModelFilters.brand = this.vehicleQuoteForm.get("qtBrand").value;
    this.carModelFilters.fuelType = this.vehicleQuoteForm.get("qtFuel").value;
    this.apiService.getCarModels(this.carModelFilters).subscribe(res => {
      this.strg.setStoreData('carmodels', res)
      this.carBrandList = res.carBrands;
      this.carModelList = res.carsInfo;
    }, err => {
    });
  }

  rtoCityList: any;
  onChangeSearchRto(event) {
    let cityName = String(event).toLowerCase()
    this.apiService.getCarRto(cityName).subscribe(res => {
      this.rtoCityList = res.data.content
    }, err => {
    })
  }
  dontKnowPolicy() {
    if (this.vehicleQuoteForm.get('qtBrand').valid && this.vehicleQuoteForm.get('qtModel').valid && this.vehicleQuoteForm.get('qtFuel').valid && this.vehicleQuoteForm.get('qtRto').valid && this.vehicleQuoteForm.get('qtRegYear').valid) {
      this.policyDontKnow = true;
      this.getVehicleQuote();
    }
    else {
      alert('Please fill remining field')
    }
  }
  noOfClaims(event) {
    this.noOfClaim = event.target.value
    let eDate = new Date()
    if(this.vehicleType.isCar === true){
    this.data = {
      "fullName": this.vehicleQuoteForm.get('qtFullName').value,
      "email": this.vehicleQuoteForm.get('qtEmail').value,
      "mobileNumber": this.vehicleQuoteForm.get('qtMobile').value,
      "vehicleRegistrationDate": this.datePipe.transform(this.getFormControl('qtRegYear').value, "yyyy-MM-dd"),
      "firstRegistrationDate": this.datePipe.transform(this.getFormControl('qtRegYear').value, "yyyy-MM-dd"),
      "isBrandNewVehicle": false,
      "businessType": this.getFormControl('owenerTransfer').value,
      "vehicleBrand": this.getFormControl('qtBrand').value,
      "vehicleFuelType": this.getFormControl('qtFuel').value,
      "vehicleModel": this.getFormControl('qtModel').value,
      "vehicleVariant": "",
      "cityRTO": this.getFormControl('qtRto').value,
      "vehicleRegistrationNumber": this.getFormControl('qtRegNumber').value,
      "policyExpiryDate": this.datePipe.transform(this.getFormControl('qtExpireEnd').value, "yyyy-MM-dd"),
      "updatedIdvValue": "0",
      "claimOnPreviousPolicy": this.ncbDetail,
      "noOfClaimsOnPreviousPolicy": this.noOfClaim,
      "previousPolicyEndDate": this.datePipe.transform(this.getFormControl('qtExpireEnd').value, "yyyy-MM-dd"),
      "previousPolicyStartDate": this.datePipe.transform(this.getFormControl('qtExpireStart').value, "yyyy-MM-dd"),
      "previousPolicyType": "Comprehensive Package",
      "isNoPrevInsurance": this.policyDontKnow,
      "otherDiscount": 0,
    }
    this.strg.setStoreData('ic_quotereq', this.data)
    this.strg.setStoreData('model', this.vehicleQuoteForm.get('qtModel').value)
    this.loader.showLoader();
    this.apiService.getVehicleQuotePublic(this.data).subscribe(res => {
      this.loader.hideLoader();
      this.strg.setStoreData('quoteres', res)
      this.router.navigate(['./vehicle-quote-plan/car']);
    }, err => {
    })
    this.showNcb = false;
  }
  }

  getVehicleQuote() {
    if (this.vehicleQuoteForm.get('qtExpireEnd').value != '') {
      this.showNcb = true;
    }
    else {
      this.showNcb = false;
      var date = new Date();
      date.setDate(date.getDate() - 3);
      if (this.rollOver === false && this.vehicleType.isCar === true) {
        this.policyDontKnow = false;
        this.data = {
          "fullName": this.vehicleQuoteForm.get('qtFullName').value,
          "email": this.vehicleQuoteForm.get('qtEmail').value,
          "mobileNumber": this.vehicleQuoteForm.get('qtMobile').value,
          "vehicleRegistrationDate": this.datePipe.transform(date, 'yyyy-MM-dd'),
          "isBrandNewVehicle": true,
          "businessType": 'New Business',
          "vehicleBrand": this.getFormControl('qtBrand').value,
          "vehicleFuelType": this.getFormControl('qtFuel').value,
          "vehicleModel": this.getFormControl('qtModel').value,
          "vehicleVariant": "",
          "cityRTO": this.getFormControl('qtRto').value,
          "vehicleRegistrationNumber": this.getFormControl('qtRegNumber').value,
          "policyExpiryDate": this.datePipe.transform(this.getFormControl('qtExpireEnd').value, "yyyy-MM-dd"),
          "isNoPrevInsurance": this.policyDontKnow,
          "updatedIdvValue": "0",
        }
      }
      else if (this.rollOver === true && this.vehicleType.isCar === true) {
        this.data = {
          "fullName": this.vehicleQuoteForm.get('qtFullName').value,
          "email": this.vehicleQuoteForm.get('qtEmail').value,
          "mobileNumber": this.vehicleQuoteForm.get('qtMobile').value,
          "vehicleRegistrationDate": this.datePipe.transform(this.getFormControl('qtRegYear').value, "yyyy-MM-dd"),
          "firstRegistrationDate": this.datePipe.transform(this.getFormControl('qtRegYear').value, "yyyy-MM-dd"),
          "isBrandNewVehicle": false,
          "businessType": this.getFormControl('owenerTransfer').value,
          "vehicleBrand": this.getFormControl('qtBrand').value,
          "vehicleFuelType": this.getFormControl('qtFuel').value,
          "vehicleModel": this.getFormControl('qtModel').value,
          "vehicleVariant": "",
          "cityRTO": this.getFormControl('qtRto').value,
          "vehicleRegistrationNumber": this.getFormControl('qtRegNumber').value,
          "policyExpiryDate": this.datePipe.transform(this.getFormControl('qtExpireEnd').value, "yyyy-MM-dd"),
          "updatedIdvValue": "0",
          "claimOnPreviousPolicy": false,
          "previousPolicyEndDate": this.datePipe.transform(this.getFormControl('qtExpireEnd').value, "yyyy-MM-dd"),
          "previousPolicyStartDate": this.datePipe.transform(this.getFormControl('qtExpireStart').value, "yyyy-MM-dd"),
          "previousPolicyType": "Comprehensive Package",
          "isNoPrevInsurance": this.policyDontKnow,
          "otherDiscount": 0,
          "bonusOnPreviousPolicy": this.ncbDetail,
          "noOfClaimsOnPreviousPolicy": this.noOfClaim
        }
      }
      if(this.vehicleType.isCar === true){
      this.strg.setStoreData('ic_quotereq', this.data)
      this.strg.setStoreData('model', this.vehicleQuoteForm.get('qtModel').value)
      this.loader.showLoader();

      this.apiService.getVehicleQuotePublic(this.data).subscribe(res => {
        this.loader.hideLoader()
        this.strg.setStoreData('quoteres', res)
        this.vehicleQuoteList.push({
          reqData:this.data,
          respData:res,
          vehicleModel:this.vehicleQuoteForm.get('qtModel').value
        }) 
        this.apiService.vehicleQuoteListChange(this.vehicleQuoteList);
        this.router.navigate(['./vehicle-quote-plan/car']);
      }, err => {
        let errs = JSON.parse(err.error.message).message
        this.loader.hideLoader()
        this.toast.showToast(errs)
      })
    }
    }
  }

  proceedWithNcb(data) {
  this.vehicleQuoteList = [];
  if(this.vehicleType.isCar === true){
    if (data === 'true') {
      this.ncbDetail = true;
      this.claimCount = 1;
      this.showNcb = false;
    }
    else if (data === 'false' || data === 'not sure') {
      this.ncbDetail = false;
      this.claimCount = 0;
      this.showNcb = false;
    }
    this.data = {
      "fullName": this.vehicleQuoteForm.get('qtFullName').value,
      "email": this.vehicleQuoteForm.get('qtEmail').value,
      "mobileNumber": this.vehicleQuoteForm.get('qtMobile').value,
      "vehicleRegistrationDate": this.datePipe.transform(this.getFormControl('qtRegYear').value, "yyyy-MM-dd"),
      "firstRegistrationDate": this.datePipe.transform(this.getFormControl('qtRegYear').value, "yyyy-MM-dd"),
      "isBrandNewVehicle": false,
      "businessType": this.getFormControl('owenerTransfer').value,
      "vehicleBrand": this.getFormControl('qtBrand').value,
      "vehicleFuelType": this.getFormControl('qtFuel').value,
      "vehicleModel": this.getFormControl('qtModel').value,
      "vehicleVariant": "",
      "cityRTO": this.getFormControl('qtRto').value,
      "vehicleRegistrationNumber": this.getFormControl('qtRegNumber').value,
      "policyExpiryDate": this.datePipe.transform(this.getFormControl('qtExpireEnd').value, "yyyy-MM-dd"),
      "updatedIdvValue": "0",
      "claimOnPreviousPolicy": this.ncbDetail,
      "noOfClaimsOnPreviousPolicy": this.claimCount,
      "previousPolicyEndDate": this.datePipe.transform(this.getFormControl('qtExpireEnd').value, "yyyy-MM-dd"),
      "previousPolicyStartDate": this.datePipe.transform(this.getFormControl('qtExpireStart').value, "yyyy-MM-dd"),
      "previousPolicyType": "Comprehensive Package",
      "isNoPrevInsurance": this.policyDontKnow,
      "otherDiscount": 0,

    }
    this.strg.setStoreData('ic_quotereq', this.data)
    this.loader.showLoader();
    this.apiService.getVehicleQuotePublic(this.data).subscribe(res => {
      this.loader.hideLoader()
      this.strg.setStoreData('quoteres', res)
      this.vehicleQuoteList.push({
        reqData:this.data,
        respData:res,
        vehicleModel:this.vehicleQuoteForm.get('qtModel').value
      }) 
      this.apiService.vehicleQuoteListChange(this.vehicleQuoteList);
      this.router.navigate(['./vehicle-quote-plan/car']);
    }, err => {
      let errorTst = JSON.parse(err.error.message).message
      this.toast.showToast(errorTst, 4000)
    })

    if (this.ncbDetail === false) {
      this.showNcb = false;
      this.noOfClaim = 0;
    }
  }
  else if(this.vehicleType.isBike === true){
    this.router.navigate(['./vehicle-quote-plan/bike']);
  }
  }
  startDate(e) {
    let day = new Date(e.target.value).getUTCDate() - 1;
    new Date(day).toISOString();
    let month = new Date(e.target.value).getMonth() + 1;
    let year = new Date(e.target.value).getFullYear() + 1;
    this.endOfDate = this.datePipe.transform(new Date(year + "-" + month + "-" + day), 'yyyy-MM-dd');
    this.vehicleQuoteForm.get('qtExpireEnd').setValue(this.endOfDate);
    if (e.target.value != null) {
      this.bothFiled = true;
    }
  }
  endDate(e) {
    if (e.target.value != null) {
      this.bothFiled = true;
    }
  }
  validateLettersOnly(event) {
    if (!/^[a-zA-Z ]*$/g.test(event.key)) {
      return false;
    } else {
      return true;
    }
  }

  validateNumericsOnly(event) {
    var key = window.event ? event.keyCode : event.which;
    if (event.keyCode == 8 || event.keyCode == 46 || event.keyCode == 39 || event.keyCode == 9) {
      return true;
    }
    else if (key < 48 || key > 57) {
      return false;
    }
    else return true;
  }

  vehicleReg(e) {
    if (e.target.value.length === 0) {
      this.withReg = false;
    }
    else if (e.target.value.length > 0) {
      this.withReg = true;
    }
  }

  calcPrevPolicyEndDate(nos, date = new Date()) {
    date.setDate(date.getDate() - nos);
    date.setFullYear(date.getFullYear() + nos);

    return date;
  }
}
function regValidate(control: AbstractControl) {
  const qtRegYear: string = control.value;
  const today = new Date();
  let regInput = new Date(qtRegYear);

  var d = new Date();
  d.setFullYear(d.getFullYear() - 1);
  if (regInput < d) {
    let year = today.getFullYear() - regInput.getFullYear();
    if (year >= 1) {
      return null;
    } else {
      return { 'regError': true };
    }
  } else {
    return { 'regError': true };
  }

}
